export enum CalendarRoot {
  WorkforceProfiles = "workforceProfiles",
  ProjectsEngagements = "projectsEngagements",
  ProjectsRoles = "projectsRoles"
}
